export const CONSUMER = 'CONSUMER';
export const PROVIDER = 'PROVIDER';
export const SELECTED_AUDIO_INPUT_KEY = 'TwilioVideoApp-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'TwilioVideoApp-selectedAudioOutput';
export const TURNOFF_VIDEO = 'TURNOFF_VIDEO';
export const MUTE_AUDIO = 'MUTE_AUDIO';
